module.exports = __webpack_public_path__ + "static/img/9.c9c893c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/9.png
// module id = MiTW
// module chunks = 0